import * as Moreprice from '../configurator/moreprice.js';
import * as Percent from '../configurator/percent.js';
import * as RequiredFields from '../configurator/requiredfields.js';
import * as Takeaway from '../configurator/takeaway';

let groupId;
let rendered = false;
let rendered2 = false;
let firstload = true;

// select stapnumber of anchor
// $(`a[href^='#upgrade_9_1']`).closest(`.content`).data(`step`)

//  scroll to anchor point
// $(function() {
//     $(document).scrollTop( $(`a[href^='#upgrade_9_3']`).offset().top -60 );
// });
const configurator = {
	currentStep: 1,
	firstLoad: true,

	init() {
		var onChangeHandlerXhr;
		this.deactivateButtons();
		Takeaway.init();
		this.accordionsAndPannels();
		this.steps();
		this.uncheckCheckboxes();
		this.onClickEvents();
		this.onChangeEvents();
		this.measureEvents();
		var host = this; `qaq`
		$(function () {
			host.loadAnchorPoint();
		});

		if (this.currentStep == 1) {
			$(`.backbutton`).hide();
		}
	},

	onChangeHandler(host = this) {
		host.deactivateButtons();
		let configurator = [];
		$(
			`.configurator input[type="number"], .configurator input[type="text"], .configurator select:selected, .configurator :checked`
		).each(function () {
			let input = $(this); // This is the jquery object of the input
			let data = {};
			data.name = input.attr("name");
			data.value = input.val() != "" ? input.val() : null;
			if (data.name) {
				configurator.push(data);
			}
		});
		let url = configuratorUrl + "/api/configurator/get";
		url = url.replace(/www\./, '');
		if(host.onChangeHandlerXhr && host.onChangeHandlerXhr.readyState != 4){
						host.onChangeHandlerXhr.abort();
		}
		$.when(
			host.onChangeHandlerXhr = $.post(
				url,
				{
					configurator,
				},
				response => {
					$(".button.button--cta.bestellen--button").off('click');

					let frameImage;
					let framePresent = false;
					if (response.frame !== null) {
						frameImage = encodeURI(response.frame);
						framePresent = true;
					}
					let isValid = true;
					$('.configurator :required').each(function () {
						if ($(this).val() === '') {
							isValid = false;
						}
					});

					if (!isValid) {
						$(".button.button--cta.bestellen--button").off('click');
						$(".button.button--cta.bestellen--button").on('click', function (e) {

							e.preventDefault();
							alert("We hebben nog niet genoeg informatie om de order aan te kunnen maken.");
						});
					} else {
						$("#button-verder-winkelen").on('click', function (e) {


							url = e.currentTarget.getAttribute('href');
							$(`#bestellen-form`).submit(function (e) {
								e.preventDefault();
								var form = $(this);


								$.ajax({

									type: "POST",
									url: url,
									data: form.serialize(),
									success: function (data) {
									let redirectUrl = window.location.href.split('/');
										window.location.href = redirectUrl[0] + "//" + redirectUrl[2] + "/" + redirectUrl[4];
									}
								});
							})
						});
						$("#button-duplicate").on('click', function (e) {


							url = e.currentTarget.getAttribute('href');
							$(`#bestellen-form`).submit(function (e) {
								e.preventDefault();
								var form = $(this);


								$.ajax({
									beforeSend: function (xhr) {
										xhr.setRequestHeader("Content-Type", "application/json");
										xhr.setRequestHeader("Accept", "text/json");
									},
									type: "POST",
									url: url,
									data: form.serialize(),

									success: function (data) {
										if ($(`input[name="basket_index"]`).attr('value') != '') {
											$(`input[name="basket_index"]`).attr('value', '');
										} else {
											$(`.fal.fa-shopping-cart`).parent().find(`span`).text(parseInt($(`.fal.fa-shopping-cart`).parent().find(`span`).text()) + 1)
										}

										$(`#session_basket`).attr('value', '');
										$(`.session-reset`).hide();
										host.goToStep1();


									}
								});
								$('form').unbind('submit')
							})
						});
					}

					groupId = response.groupId;
					$.each(response, function (index, item) {
						if (index == "sessionArray") {
							let postUrl = window.location.href;
							postUrl = postUrl.replace("/configuration", "");
							$.post(postUrl, response["sessionArray"]);
						}
						if (item !== null) {
							//set values on order tab

							$(`.${index}_order_configuration .item__text__content`).text($(`input[type="number"][name="${index}"]`).val() ? $(`input[type="number"][name="${index}"]`).val() : (item.value || ``) +
								(item.value == null ? `` : (item.description == null ? ` ` : ` - `)) +
								(item.description || ``));

							$(`.${index} .item__text__content`).text((item.value || ``) +
								(item.value == null ? `` : (item.description == null ? ` ` : ` - `)) +
								(item.description || ``));
							$(`.${index} .item__text__content`).text(
								$(`input[type="number"][name="${index}"]`).val()
							);

							//set accordion headers
							$(`#title_${index}`).text((item.value || ``));
							$(`${index} .item__text__content`).text(
								$(`input[type="number"][name="${index}"]`).val()
							);

							if ($(`option[name="${index}"]:selected`).text()) {
								$(`.${index}_order_configuration .item__text__content`).text(
									$(`option[name="${index}"]:selected`).text()

								);
							}

							let image = encodeURI(item.image);

							$(`.${index} .item__color`).css(
								"background-image",
								`url(/e2/zonscherm/site/custom/${item.image})`
							);

							//select labels on colors
							$(`input[value="${item.id}"]`).closest(`div`).find(`label`).addClass('selected');
						
							host.
							setTextures(item, index);
						}
						if ($(`#${index}.renew`).is("select")) {
							$(`#${index}`)
								.find("option")
								.remove()
								.end();

							$.each(item, function (i, item) {
								$(`#${index}`).append(
									$("<option></option>")
										.attr("name", index)
										.attr("value", item.id)
										.text(item.value)
								);
							});
						}
						if (index == "request") {
							$(`#${item.name} option[value="${item.value}"]`).prop('selected', true);
						}
						if (index == "price") {
							$(".bestellen__price__text").text(
								`€ ${(Number(item) * 1.0).toLocaleString("nl-NL")}`
							);
						}
						if (index == "basicprice") {
							$("#basicprice").text(
								`${(Number(item) * 100)}`
							);
						}

						if (index == "minmaxvalue") {
							$(`input[name="option_${groupId}_${item['optionId']}"]`).attr('min', item['min']);
							$(`input[name="option_${groupId}_${item['optionId']}"]`).attr('max', item['max']);
							$(`input[name="option_${groupId}_${item['optionId']}"]`).parent().parent().find(`.text__small`).html(`(${item['min']} - ${item['max']} mm)`);
							$(`select[name="option_${groupId}_${item['optionId']}"]`).parent().parent().find(`.text__small`).html(`(${item['min']} - ${item['max']} mm)`);
							if (($(`input[name="option_${groupId}_${item['optionId']}"]`).val() != '') && (
								$(`input[name="option_${groupId}_${item['optionId']}"]`).val() < item['min'] ||
								$(`input[name="option_${groupId}_${item['optionId']}"]`).val() > item['max'])) {
									alert($(`input[name="option_${groupId}_${item['optionId']}"]`).parent().parent().find(`b`).text() + ' ' + $(`input[name="option_${groupId}_${item['optionId']}"]`).val() + ' is niet mogelijk');
									$(`input[name="option_${groupId}_${item['optionId']}"]`).val('');
							}
							$(`select[name="option_${groupId}_${item['optionId']}"] > option`).each(function () {

								if ((parseInt(this.text) >= item['min']) && (parseInt(this.text) <= item['max'])) {
									$(this).show();
								} else {
									$(this).hide();
								}
							})
						}

						if (index == "axis") {
							let xvalue;
							let yvalue;
							$.each(item, function (axisindex, axisitem) {
								if (axisindex == "x") {
									xvalue = parseInt($(`input[name="option_${groupId}_${axisitem}"]`).val());
								} else {
									yvalue = parseInt($(`input[name="option_${groupId}_${axisitem}"]`).val());
								}
								if (xvalue & yvalue) {
									$('[data-min_x]').each(function () {
										let showOption = false;
										let min_x = $(this).data(`min_x`);
										let max_x = $(this).data(`max_x`);
										let min_y = $(this).data(`min_y`);
										let max_y = $(this).data(`max_y`);
										let min_x_bool, max_x_bool, min_y_bool, max_y_bool;

										if (min_x == 0) {
											min_x_bool = true;
										} else if (min_x <= xvalue) {
											min_x_bool = true;
										} else {
											min_x_bool = false;
										}

										if (max_x == 0) {
											max_x_bool = true;
										} else if (max_x >= xvalue) {
											max_x_bool = true;
										} else {
											max_x_bool = false;
										}

										if (min_y == 0) {
											min_y_bool = true;
										} else if (min_y <= yvalue) {
											min_y_bool = true;
										} else {
											min_y_bool = false;
										}

										if (max_y == 0) {
											max_y_bool = true;
										} else if (max_y >= yvalue) {
											max_y_bool = true;
										} else {
											max_y_bool = false;
										}
										if (min_x_bool && max_x_bool && min_y_bool && max_y_bool) {
											$(this).closest(`div.option`).removeClass(`hidden`);
										} else {
											$(this).closest(`div.option`).addClass(`hidden`);
											$(this).closest(`div.option`).children('input[type="radio"]').prop(`checked`, false);
										}


									});
								}
							});
						}


						if (index == "ral_prices") {
							$.each(item, function (ralindex, ralitem) {
								$(`#ral_${ralindex}_price`).text(
									`€ ${(Number(ralitem) * 1.0).toLocaleString("nl-NL")}`
								);
							});
						}
						if (index == "product") {
							$('#bestellen-form').attr('action', '/purchase/basket');
							$('#bestellen-form input').remove();
							var hidden = `<input type="hidden" name="basket_parent" value="${item.id}"></input>`;
							$('#bestellen-form').append(hidden);
							var hidden = `<input type="hidden" name="basket_product[${item.id}]" value="1"></input>`;
							$('#bestellen-form').append(hidden);

							$(".bestellen--button--html").attr(
								"href",
								`/purchase/basket?basket_parent=${item.id}&basket_product[${item.id
								}]=1`
							);

							$(".bestellen--button--json").attr(
								"href",
								`/shop_json/purchase/basket?basket_parent=${item.id}&basket_product[${item.id
								}]=1`
							);
							$.each(item, function (productindex, productitem) {
								if (productindex == "bundle") {
									$.each(productitem, function (bundleindex, bundleitem) {
										//form
										var hidden = `<input type="hidden" name="basket_product[${bundleitem}]" value="1"></input>`;
										$('#bestellen-form').append(hidden);
										//endform
										let _href = $(".bestellen--button--html").attr("href");
										$(".bestellen--button--html").attr(
											"href",
											`${_href}&basket_product[${bundleitem}]=1`
										);
										_href = $(".bestellen--button--json").attr("href");
										$(".bestellen--button--json").attr(
											"href",
											`${_href}&basket_product[${bundleitem}]=1`
										);
									});
								}
								if (productindex == "shopinfo") {
									$.each(productitem, function (shopinfoindex, shopinfoitem) {
										$(`.shopinfo.${shopinfoitem.title.replace(" ", "")}`).html("");
										$(`.shopinfo.${shopinfoitem.title.replace(" ", "")}`).append(`<span class="item__text__content">${shopinfoitem.value}</span><br>`);
									});
								}
								if (productindex == "upsell") {
									$.each(productitem, function (upsellindex, upsellitem) {
										//form
										var hidden = `<input type="hidden" name="basket_product[${upsellitem.productid}]" value="${upsellitem.quantity
											}"></input>`;
										$('#bestellen-form').append(hidden);
										//endform

										let _href = $(".bestellen--button--html").attr("href");
										$(".bestellen--button--html").attr(
											"href",
											`${_href}&basket_product[${upsellitem.productid}]=${upsellitem.quantity
											}`
										);
										_href = $(".bestellen--button--json").attr("href");
										$(".bestellen--button--json").attr(
											"href",
											`${_href}&basket_product[${upsellitem.productid}]=${upsellitem.quantity
											}`
										);
									});
								}
							});
							let _href = $(".bestellen--button--html").attr("href");
							//form
							let sessionId = $("input#session_basket").val();
							var hidden = `<input type="hidden" name="basket_index" value="${sessionId}"></input>`;
							$('#bestellen-form').append(hidden);
							//endform

							$(".bestellen--button--html").attr(
								"href",
								_href + `&basket_index=` + $("input#session_basket").val()
							);
							_href = $(".bestellen--button--json").attr("href");
							$(".bestellen--button--json").attr(
								"href",
								_href + `&basket_index=` + $("input#session_basket").val()
							);
						}
						if (index == "takeaway") {
							//form
							let sessionId = $("input#session_basket").val();
							var hidden = `<input type="hidden" name="basket_department" value="${item}"></input>`;
							$('#bestellen-form').append(hidden);
							let _href = $(".bestellen--button--html").attr("href");
							$(".bestellen--button--html").attr(
								"href",
								_href + `&basket_department=` + item
							);
							_href = $(".bestellen--button--json").attr("href");
							$(".bestellen--button--json").attr(
								"href",
								_href + `&basket_department=` + item
							);
						}
					});

				}

			)
		).done(function () {
			RequiredFields.checkStepCompleted();
			Moreprice.changePrices();
			Percent.toPrice();
			if ($(`.content__kleur`).is(':visible') && host.firstLoad == false) {
				$(window).scrollTop(0).offset().top;
			}
			host.setKnowInformationinScreens();
			host.setRenderInSession(host.activateButtons);
			host.firstLoad = false;
		}).fail(function () {

		});
	},

	/**
	 * Go to a selected tab in color content
	 *
	 * @param {event} e
	 */
	switchColorTab(e) {
		this.currentColorTab = $(e.currentTarget).data("color-tab");

		// Remove highlight old tab
		$(".content__kleur .tab").removeClass("tab--chosen");
		$(`.content__kleur .tab .icon`)
			.removeClass()
			.addClass("fas fa-angle-left icon");

		// Highlight new tab
		$(
			`.content__kleur .tab[data-color-tab="${this.currentColorTab}"]`
		).addClass("tab--chosen");
		$(`.content__kleur .tab[data-color-tab="${this.currentColorTab}"] .icon`)
			.removeClass()
			.addClass("fas fa-angle-down icon");

		// hide old content and show new content
		$(`.content__kleur  .row--items[data-color-tab]`).hide();
		$(
			`.content__kleur  .row--items[data-color-tab="${this.currentColorTab}"]`
		).show();
	},

	/**
	 * Change the class of bediening
	 *
	 * @param {event} e
	 */
	selectBediening(e) {
		this.currentBediening = $(e.target).next(`label`).data("bediening");
		this.currentLabel = $(`label[for="${this.currentBediening}"]`).find(`.title`).text();
		$(".content__bediening .row.selected").removeClass("selected");

		//set accordion headders
		// $(`#title_${e.target.name}`).html(`- ${this.currentLabel}`);

		$(
			`.content__bediening .row[data-bediening="${this.currentBediening}"]`
		).addClass("selected");
		if (typeof this.currentBediening !== "undefined") {
			// Select only bundles with associated upgrades
			$(
				`.option[data-upgrade][data-upgrade*="${this.currentBediening.split("[")[0]
				}"]`
			).hide();
			$(
				`.option[data-upgrade][data-upgrade*="${this.currentBediening.split("[")[0]
				}"]`
			).children('input[type="radio"]').prop('checked', false);
			$(
				`.option[data-upgrade-value*="${this.currentBediening.match(/\[(.*?)\]/)[1]
				}"][data-upgrade*="${this.currentBediening.split("[")[0]}"]`
			).show();
		}
		if ($(e.target).is('input[type="checkbox"]')) {
			this.quantity = $(e.target).next(`label`).children(`div.quantity`).children(`input`);
			//Checkbox is checked
			if ($(e.target).prop('checked')) {
				// set 1 in next textbox (quantity) when value is empty
				(!this.quantity.val()) ? this.quantity.val(`1`) : ``;
			} else {
				//checkbox is not checked, remove quantity
				this.quantity.val(``)
			}

		}
		// Set checkbox on when an value is set in quantity
		if ($(e.target).is('input.upsell-input')) {
			if ($(e.target).val()) {
				$(e.target).parents(`.option`).children('input[type="checkbox"]').prop(`checked`, true);
			}
		}
		this.switchAccordion(e);

	},

	switchAccordion(e) {
		this.quantity = $(e.target).parent().children('label').children('.quantity');
		if ($(this.quantity).length) {
			$(this.quantity).children(`input`).focus();
		} else {
			this.inputfield = $(e.target).parent().children('input[type="radio"]');
			if ($(this.inputfield).length) {
				this.previousPanel = $(e.target).closest("div.show");
				$(this.previousPanel).removeClass("show");
				this.previousAccordion = $(this.previousPanel).prev(".active");
				$(this.previousAccordion).removeClass("active");


				this.nextAccordion = $(this.previousAccordion).nextAll(".accordion:visible:first");
				if ($(this.nextAccordion).length) {
					$(this.nextAccordion).addClass("active");
					$(this.nextAccordion).next(".panel").addClass("show");
					$('html, body').animate({
						scrollTop: $(this.previousAccordion).offset().top - $(".header").height() - 10
					}, 1000);
				} else {
					$('html, body').animate({
						scrollTop: $(".topbar").offset().top - $(".header").height()
					}, 1000);
				}
			}
		}
	},
	selectUpsell(e) {
		this.currentBundel = $(e.currentTarget).data("upsell");
		if (
			$(`.content__bundel .row[data-bundel="${this.currentBundel}"]`).hasClass(
				"selected"
			)
		) {
			$(
				`.content__bundel .row[data-bundel="${this.currentBundel}"]`
			).removeClass("selected");
		} else {
			$(`.content__bundel .row[data-bundel="${this.currentBundel}"]`).addClass(
				"selected"
			);
		}
	},
	/**
	 * Change to current content
	 */
	changeGroup(e) {
		this.currentGroup = $(e.currentTarget).data("group");
		$(`.choice__item`).removeClass("selected");
		$(`.choice__item[data-group="${this.currentGroup}"]`).addClass("selected");
		$(`.group`).hide();
		$(`.group[data-group="${this.currentGroup}"]`).show();
		// Remove highlight old tab
		$(".content__kleur .tab").removeClass("tab--chosen");
		$(`.content__kleur .tab .icon`)
			.removeClass()
			.addClass("fas fa-angle-left icon");

		// Highlight new tab
		$(
			`.content__kleur .tab[data-color-tab^="${this.currentGroup}"]:first`
		).addClass("tab--chosen");
		$(
			`.content__kleur .tab[data-color-tab^="${this.currentGroup}"]:first .icon`
		)
			.removeClass()
			.addClass("fas fa-angle-down icon");

		// hide old content and show new content
		$(`.content__kleur_group.row--items[data-color-tab]`).hide();
		$(
			`.content__kleur_group.row--items[data-color-tab^="${this.currentGroup
			}"]:first`
		).show();
	},
	/**
	 * Go to a selected step
	 *
	 * @param {event} e
	 */
	clickStep(e) {

		this.currentStep = $(e.currentTarget).data("step");
		this.switchStep();
	},

	goToStep1() {

		this.currentStep = 1;
		this.switchStep();
	},

	/**
	 * Go one step back
	 *
	 * @param {event} e
	 */
	backStep(e) {
		if (this.currentStep > 1) {
			this.currentStep--;
			if (this.currentStep == 1) {
				$(`.back-button`).hide();
			}
			this.switchStep();
		}
	},

	/**
	 * Go to the next step
	 *
	 * @param {event} e
	 */
	nextStep(e) {
		if (this.currentStep < 7) {
			$(`.back-button`).show();
			this.currentStep++;
			this.switchStep();
		}
	},

	/**
	 * Go to a specific step
	 */
	switchStep() {
		// $(`.loading`).show();
		this.currentStep === 1
			? $(".back-button").hide()
			: $(".back-button").show();

		if (this.currentStep == $(`.rightcolumn`).data('bestelstap')) {
			$(".next-button").hide()
		} else {
			$(".next-button").show();
		}
		$(".steps__step.is--active").removeClass("is--active");

		this.showStap(this.showProductRender);

		//Hide accordion when there are no (bundle, upsells, upgrades)
		$('.panel').each(function () {
			$(this).prev().show();
			if ($(this).children(":visible").length == 0) {
				$(this).prev(".accordion").hide();
			}
		})
		// open first accordion
		var acc = document.getElementsByClassName("accordion");
			var panel = document.getElementsByClassName('panel');

			for (var i = 0; i < acc.length; i++) {
				
					
					setClass(acc, 'active', 'remove');
				setClass(panel, 'show', 'remove');
				console.log(i);
					console.log(acc[i].parentNode.style.display);
				if (acc[i].parentNode.style.display != 'none' && acc[i].style.display != 'none') {
					
					acc[i].classList.toggle("active");
					acc[i].nextElementSibling.classList.toggle("show");
					break;
				}
					
			}
		function setClass(els, className, fnName) {
				for (var i = 0; i < els.length; i++) {
					els[i].classList[fnName](className);
				}
			}
	},
	setRenderInSession(activateButtons) {
		if (this.currentStep == $(`.rightcolumn`).data('bestelstap')) {
			if ($(`#renderer2`).length != 0) {
				$(`#renderer2`).empty();
				// for (let index = 0; index < 1; index++) {
				try {
					let imageNumber = 0;
					// if ([rotator_type] == 'screen') {
					//    imageNumber = 2;
					// }
					let imgRender = `${rotator[rotator_type].image(imageNumber)}`

					$(`#renderer2`).prepend(`<img id="render0" src="${imgRender}" />`)
					// }
					let infoArray = [];
					infoArray = {
						[`info_${groupId}`]: {
							image: {
								configurator: { name: "image", hidden: 1, value: imgRender },
							},
						},
					};
					let postUrl = window.location.href;
					postUrl = postUrl.replace("/configuration", "");
					$.when(
						$.post(postUrl, infoArray)
					).done(function () {
						activateButtons();
					});
				}
				catch (err) {

				}
			} else {
				activateButtons();
			}
		} else {
			activateButtons();
		}
	},
	activateButtons() {
		$(`.steps`).show();
		$(`.bestellen--button`).removeClass('disabled');
		$(`.bestellen--button`).attr('disabled', false);
	},
	deactivateButtons() {
		$(`.bestellen--button`).addClass('disabled');
		$(`.bestellen--button`).attr('disabled', true);
	},
	/**
	 * Change top title
	 */
	changeTopTitle() {
		$(`.topbar__text__center > span`).hide();
		$(`.topbar__text__center > span[data-step="${this.currentStep}"]`).show();
	},

	/**
	 * Change to current content
	 */
	changeContent() {
		$(`.content`).hide();
		$(`.content[data-step="${this.currentStep}"]`).show();
	},

	allowedValue(element) {

		var min = parseInt(element.getAttribute("min")) || false;
		var max = parseInt(element.getAttribute("max")) || false;

		var value = parseInt(element.value);
		element.value = value; // make sure we got an int

		if (min && value < min) {
			element.value = '';
			element.placeholder = `Waarde moet minimaal ${min} zijn!`;

		}
		if (max && value > max) {
			element.value = '';
			element.placeholder = `Waarde mag maximaal ${max} zijn!`;
		}

	},
	showStap(showProductRender) {
		$(`.steps__step[data-step="${this.currentStep}"]`).addClass("is--active");
		this.changeTopTitle();
		this.changeContent();
		showProductRender(this.onChangeHandler, this);
	},
	showProductRender(onChangeHandler, nowThis) {
		if (typeof rotator_type !== 'undefined') {
			if (rotator_type == "roller") {
				$(`#renderer`).css('height', '500px');
				$(`#renderer2`).css('height', '300px');
			}
			if ($(`#renderer`).is(":visible")) {

				if ($(`#renderer`).find(`canvas`).length === 0) {
					let url = configuratorUrl;
					url = url.replace(/www\./, '');
					let peaces = $(`input[data-peaces]:checked`).data('peaces');
					peaces = (peaces) ? parseInt(peaces.substr(0, 2)) : 0;
					let modelUrl = (peaces > 0) ? `${url}/sketchmodel/${image_configurator}-${peaces}.glb` : `${url}/sketchmodel/${image_configurator}.glb`;
					rotator[rotator_type].set({
						element: document.getElementById('renderer'),
						model: modelUrl,
						interaction: true
					});
				}
			} else {
				if ($(`#renderer2`).is(":visible")) {

					if ($(`#renderer`).find(`canvas`).length === 0) {
						let url = configuratorUrl;
						url = url.replace(/www\./, '');
						let peaces = $(`input[data-peaces]:checked`).data('peaces');
						peaces = (peaces) ? parseInt(peaces.substr(0, 2)) : 0;
						let modelUrl = (peaces > 0) ? `${url}/sketchmodel/${image_configurator}-${peaces}.glb` : `${url}/sketchmodel/${image_configurator}.glb`;
						rotator[rotator_type].set({
							element: document.getElementById('renderer2'),
							model: modelUrl,
							interaction: true
						});
					}

				}

			}
		}
		onChangeHandler(nowThis);
	},

	accordionsAndPannels() {
		document.addEventListener("DOMContentLoaded", function (event) {


			var acc = document.getElementsByClassName("accordion");
			var panel = document.getElementsByClassName('panel');

			for (var i = 0; i < acc.length; i++) {
				acc[i].onclick = function () {
					var setClasses = !this.classList.contains('active');
					setClass(acc, 'active', 'remove');
					setClass(panel, 'show', 'remove');

					if (setClasses) {
						this.classList.toggle("active");
						this.nextElementSibling.classList.toggle("show");
					}
				}
			}

			function setClass(els, className, fnName) {
				for (var i = 0; i < els.length; i++) {
					els[i].classList[fnName](className);
				}
			}
		});
	},
	steps() {
		$(".configurator .steps > li").on("click", $.proxy(this.clickStep, this));
		$(".configurator .topbar__text")
			.children("a")
			.eq(0)
			.on("click", $.proxy(this.backStep, this));
		$(".configurator .topbar__text")
			.children("a")
			.eq(1)
			.on("click", $.proxy(this.nextStep, this));

		$(".configurator .bottombar__text")
			.children("a")
			.eq(0)
			.on("click", $.proxy(this.backStep, this));
		$(".configurator .bottombar__text")
			.children("a")
			.eq(1)
			.on("click", $.proxy(this.nextStep, this));
	},
	uncheckCheckboxes() {
		//uncheck checkboxes
		var allRadios = $("input:radio");
		var booRadio;
		var x = 0;
		for (x = 0; x < allRadios.length; x++) {
			allRadios[x].onclick = function () {
				if (booRadio == this) {
					this.checked = false;
					RequiredFields.checkStepCompleted();
					booRadio = null;
				} else {
					booRadio = this;
				}
			};
		}
	},
	onClickEvents() {
		// color content
		$(".choice__item").on("click", $.proxy(this.changeGroup, this));
		$(".content__kleur .tab").on("click", $.proxy(this.switchColorTab, this));
		$(".content__kleur label").on("click", $.proxy(this.switchColor, this));
		//Bundel
		// $('.content__bundel label').on('click', $.proxy(this.selectBundel, this));

		//Upsell
		$(".content__upsell label").on("click", $.proxy(this.selectUpsell, this));
	},

	switchColor(item) {
		$(item.currentTarget).closest(`div[data-group]`).find(`label`).removeClass('selected');
		$(item.currentTarget).addClass('selected');
		// $(`.upgrade_6_1`).parent().find(`label`)
	},
	onChangeEvents() {
		//Bediening
		$(".content__bediening input").on(
			"change",
			$.proxy(this.selectBediening, this)
		);

		$(`.configurator :radio, .configurator :checkbox, .configurator .text__dropdown, .configurator select`).each((index, element) => {
			let input = $(element);
			input.on("change", () => {
				this.onChangeHandler();
			});
		});
		this.removeCanvasOnDataPeacesChange();
	},
	measureEvents() {
		// Order
		$(`.configurator input[type="number"]`).each((index, element) => {
			let input = $(element);
			input.on("focusout", () => {
				this.onChangeHandler();
				this.allowedValue(element);
			});
			input.on("keyup", () => {

				if (parseInt(element.value) >= $(input).attr('min') && parseInt(element.value) <= $(input).attr('max')) {


					this.onChangeHandler();
				}

			});
			input.on("click", () => {
				this.onChangeHandler();
			});
		});
	},

	removeCanvasOnDataPeacesChange() {
		//remove rotator canvas when data-peaches change
		$(`input[data-peaces]`).on("change", () => {
			$(`#renderer`).find(`canvas`).remove();
		});
	},
	setKnowInformationinScreens() {
		// set bij te bestellen @ bestellen tab
		$(`.Bijtebestellen`).html(``);
		$(`.configurator .content__bediening input[type="checkbox"]:checked`).each(function () {
			let Bijtebestellen = $(this).parent().children('label').children(`.text`).first().children(`p`).text();
			let AantalBijtebestellen = $(this).parent().children('label').children(`.quantity`).first().children(`input`).val();
			$(`.Bijtebestellen`).append(`<span class="item__text__content">${AantalBijtebestellen}x ${Bijtebestellen}</span><br>`);
		});
		if ($(`.Bijtebestellen`).html() === '') $(`.Bijtebestellen`).html(`<span class="item__text__content">Geen keuze gemaakt</span>`);

		// set levering @ bestellen tab
		$(`.Levering`).html(``);
		$(`.configurator .levering input[type="checkbox"]:checked`).each(function () {
			let levering = $(this).parent().children('label').children(`div`).first().children(`p`).text();
			if (levering == "Afhalen") {
				levering = levering + " in " + $(`select#location option:selected`).text();
			}
			$(`.Levering`).append(`<span class="item__text__content">${levering}</span><br>`);
		});
		if ($(`.Levering`).html() === '') $(`.Levering`).html(`<span class="item__text__content">Geen keuze gemaakt</span>`);

		// set bundle @ bestellen tab
		($(`[data-bundel]:checked`).length === 0) ? $(`.bundle_bundle`).parent('li').hide() : $(`.bundle_bundle`).parent('li').show();
		$(`#bundle`).html("");
		$(`#bundle`).html(($(`[data-bundel]:checked`).length === 0) ? "" : $(`[data-bundel]:checked`).parent(`div`).find(`b`).text());
		$(`.bundle_bundle`).html(``);
		$(`.bundle_bundle`).append(($(`[data-bundel]:checked`).length === 0) ? '<span class="item__text__content">Geen keuze gemaakt</span>' : $(`[data-bundel]:checked`).parent(`div`).find(`b`).text());
	},
	setTextures(item, index) {
		try {

			if ($(`#renderer`).is(":visible") || $(`#renderer2`).is(":visible")) {

				let upgradeType = $(`.${index} .item__text__header`).text();
				if (upgradeType == "Doekkleur") {
					rotator[rotator_type].texture('canvas', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Systeemkleur") {
					if (rotator_type == "schuifpui") {
						rotator[rotator_type].texture('schuifpui', `/e2/zonscherm/site/custom/${item.image}`);
					} else if (rotator_type == "schutting") {
						rotator[rotator_type].texture('systeemkleur', `/e2/zonscherm/site/custom/${item.image}`);
					}
					else {
						rotator[rotator_type].texture('frame', `/e2/zonscherm/site/custom/${item.image}`);
					}
				}
				if (upgradeType == "Kleur pantser") {
					rotator[rotator_type].texture('pantser', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur omkasting") {
					rotator[rotator_type].texture('omkasting', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur geleideaars") {
					rotator[rotator_type].texture('geleider', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur onderlijst") {
					rotator[rotator_type].texture('onderlijst', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur grepen") {
					rotator[rotator_type].texture('klinken', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur bovenrail en bovenzijde glaslijst") {
					rotator[rotator_type].texture('glass_holder', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur onderrail en onderzijde glaslijst") {
					rotator[rotator_type].texture('rail', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur scharnieren") {
					rotator[rotator_type].texture('scharnieren', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur") {
					rotator[rotator_type].texture('kleur', `/e2/zonscherm/site/custom/${item.image}`);
				}
				if (upgradeType == "Kleur ladderband") {
					rotator[rotator_type].texture('ladderband', `/e2/zonscherm/site/custom/${item.image}`);
				}
			}
		}
		catch (err) {
		}
	},
	loadAnchorPoint() {

		let anchor = window.location.hash.substr(1);
		if (anchor != "") {
			if ($(`.${anchor}`).hasClass('value_item')) {
				anchor = $(`.${anchor}`).attr('name');
			}
			let anchorStep = ($(`.${anchor}`).closest(`.content`).data(`step`));
			this.currentStep = anchorStep;
			this.switchStep();
			$(function () {
				$(document).scrollTop($(`.${anchor}`).offset().top - 70);
				$(`.${anchor}`).trigger('click')
			});

	}else{

		this.onChangeHandler();
		}


	}
};

export default configurator.init();